import { Page as Component } from "~/components/specifics/admin/vendor_companies/Page";

export function Page() {
	return <Component />;
}
